import {
    HttpResponse,
    FolderModel,
    QueryModel,
    RequestParams,
    FolderModelIEnumerableApiResultSuccess,
    FolderModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class FoldersDataService implements CrudService<FolderModel, FolderModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<FolderModel>): Promise<CrudListResponse<FolderModel>> {
        return ApiService.api.getFolderBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<FolderModel>> {
        return ApiService.api.getFolderById(id, params);
    }

    create(item: FolderModel, params?: RequestParams): Promise<CrudResponse<FolderModel>> {
        throw "NotImplemented";
    }

    update(item: FolderModel, params?: RequestParams): Promise<FolderModel> {
        return ApiService.api.updateFolder(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<FolderModel> {
        return ApiService.api.patchFolder(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<FolderModel>): Promise<CrudListResponse<FolderModel>> {
        return ApiService.api.deleteFolders(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<FolderModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
